module.exports = __webpack_public_path__ + "static/media/LogoText.60240b20.svg";